import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * MarketSort Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;
    
    /**
     * Sort by this items
     */
    @Prop({ type: Array }) sortBy!: Array<object>;

    /**
     * Sort, ordered by this items
     */
    @Prop({ type: Array }) orderBy!: Array<object>;

    /**
     * Show order items
     */
    @Prop({ type: Boolean }) order!: Boolean;
}
